import { render, staticRenderFns } from "./svg-icon-max.vue?vue&type=template&id=a0ae85de&"
import script from "./svg-icon-max.vue?vue&type=script&lang=js&"
export * from "./svg-icon-max.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0ae85de')) {
      api.createRecord('a0ae85de', component.options)
    } else {
      api.reload('a0ae85de', component.options)
    }
    module.hot.accept("./svg-icon-max.vue?vue&type=template&id=a0ae85de&", function () {
      api.rerender('a0ae85de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/svg-icon-max.vue"
export default component.exports